import { render, staticRenderFns } from "./Rewards.vue?vue&type=template&id=04eff98e&scoped=true"
import script from "./Rewards.vue?vue&type=script&lang=js"
export * from "./Rewards.vue?vue&type=script&lang=js"
import style0 from "./Rewards.vue?vue&type=style&index=0&id=04eff98e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04eff98e",
  null
  
)

export default component.exports